import * as R from 'ramda';

const initialTabState = {
  id: '',
  type: 'entity',
  name: '',
  route: '',
  system: true,
  closeable: true,
  pinnable: true,
  color: undefined,
  icon: undefined,
};

// OPEN_TAB

/*
const initialState = {
  tabs: {
    '/window/home': {
      ...initialTabState,
      id: '/window/home',
      icon: 'home',
      route: '/window/home',
      closeable: false,
      type: 'fixed',
    },
    '/window/browse': {
      ...initialTabState,
      id: '/window/browse',
      icon: 'folder',
      route: '/window/categories',
      closeable: false,
      type: 'fixed',
    },
  },
  __loading: false,
};
*/


const initialState = {
  byId: {},
  draftsById: {},
  keyWindows: ['/window/home', '/window/browse'],
  '/window/home': {
    isLoading: false,
    type: 'home',
    isPinned: true,
    id: '/window/home',
  },
  '/window/browse': {
    isLoading: false,
    type: 'browse',
    isPinned: true,
    id: '/window/browse',
  },
};

const tabReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'FETCH_ALL_TABS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: true,
        },
      };
    case 'RECEIVE_ENTITIES':
      return {
        ...state,
        byId: {
          ...state.byId,
          ...R.path(['payload', 'entities', 'tabs', 'byId'], action),
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          ids: R.path(['payload', 'entities', 'tabs', 'ids'], action),
        },
      };
    case 'RELEASE_KEY_WINDOW':
      return {
        ...R.omit([action.payload.keyWindow], state),
        keyWindows: state.keyWindows.filter(kw => kw !== action.payload.keyWindow),
      };
    default:
      return state;
  }
};

export default tabReducer;
